import { motion } from 'framer-motion';

export const ReviewButton = () => {
  return (
    <motion.a
      href="https://play.google.com/store/apps/details?id=com.dishashool.dishashool&hl=en_IN"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="bg-yellow-400 text-gray-900 px-8 py-3 rounded-t-none rounded-b-full font-semibold text-lg shadow-lg hover:bg-yellow-300 transition-colors duration-200">
        कृपया गूगल प्ले में रेटिंग दें →
      </div>
    </motion.a>
  );
};